export const BONUS_CONSTANTS = {
  MAX_ATTEMPTS: 3,
  SUCCESS_STATUS: 2,
  DEFAULT_ATTEMPT: 1,
};
